import React from "react";
import Container from "../ui/Container";
import Eyebrow from "../ui/Eyebrow";
import HomeAppCtas from "./HomeAppCtas";

// Home lifestyle SVG from Untitled design (1).zip — 3.svg
const HERO_TRANSIT_SRC = "/images/home-lifestyle-bus.svg";
const HERO_TRANSIT_W = 1512;
const HERO_TRANSIT_H = 828;

const BENEFIT_STEPS = [
  {
    n: "01",
    title: "Build your rules",
    body: "Connect your holdings and define your buy and sell conditions.",
    icon: "rules",
  },
  {
    n: "02",
    title: "Test on history",
    body: "See how your strategy would have performed.",
    icon: "history",
  },
  {
    n: "03",
    title: "Run in paper",
    body: "Let cloud paper trading follow your rules with fill notifications.",
    icon: "paper",
  },
];

function StepIcon({ name }) {
  const common = {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  return (
    <span
      aria-hidden="true"
      className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full ring-1 ring-ink/10"
    >
      <svg viewBox="0 0 24 24" className="h-4 w-4 text-ink/70" {...common}>
        {name === "rules" ? (
          <>
            <path d="M8 6h10" />
            <path d="M8 12h10" />
            <path d="M8 18h7" />
            <path d="M5 6h.01" />
            <path d="M5 12h.01" />
            <path d="M5 18h.01" />
          </>
        ) : null}
        {name === "history" ? (
          <>
            <path d="M4 19V6" />
            <path d="M4 19h16" />
            <path d="M7 15l3-4 3 2 5-7" />
          </>
        ) : null}
        {name === "paper" ? (
          <>
            <path d="M12 7a5 5 0 0 1 5 5v5H7v-5a5 5 0 0 1 5-5z" />
            <path d="M10 20h4" />
            <path d="M9 4h6" />
          </>
        ) : null}
      </svg>
    </span>
  );
}

export default function PortfolioFreedomSection() {
  return (
    <section className="relative overflow-x-clip bg-bg0">
      <div className="lifestyle-split">
        <Container className="lifestyle-copy relative z-10 flex items-center">
          <div className="flex max-w-xl flex-col justify-center py-6 md:py-8 xl:py-0">
            <Eyebrow>Your portfolio. Your rules.</Eyebrow>
            <h2 className="mt-5 text-[clamp(2.25rem,0.7rem+3.2vw,3.85rem)] font-semibold leading-[1.05] tracking-display text-ink">
              Take your day
              <br />
              back.{" "}
              <em className="font-serif italic font-normal tracking-normal text-[#1a3d46]">
                Your rules
              </em>
              <br />
              come with you.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-muted md:text-lg">
              Build and backtest your own strategies. Let cloud paper trading follow your
              rules, with fill notifications wherever your day takes you.
            </p>
            <HomeAppCtas className="mt-8" />
            <p className="mt-5 text-[12px] text-muted">
              No-code strategies · iOS app · Paper automation
            </p>
          </div>
        </Container>

        <img
          src={HERO_TRANSIT_SRC}
          alt="A Stratify paper-fill notification on iPhone while commuting"
          width={HERO_TRANSIT_W}
          height={HERO_TRANSIT_H}
          loading="lazy"
          decoding="async"
          className="hero-lifestyle z-0"
        />
      </div>

      <Container className="relative z-10 pb-16 pt-12 md:pb-20 lg:pt-6">
        <h2 className="max-w-3xl text-3xl font-semibold tracking-display text-ink md:text-4xl lg:text-[2.65rem]">
          Less screen time. A more consistent process.
        </h2>
        <ol className="mt-10 grid gap-8 sm:grid-cols-3 sm:gap-6">
          {BENEFIT_STEPS.map((step) => (
            <li key={step.n} className="flex gap-3">
              <StepIcon name={step.icon} />
              <div>
                <div className="flex items-baseline gap-2 text-[12px] font-semibold tracking-tight text-ink">
                  <span className="text-muted">{step.n}</span>
                  <span>{step.title}</span>
                </div>
                <p className="mt-2 max-w-xs text-sm leading-relaxed text-muted">{step.body}</p>
              </div>
            </li>
          ))}
        </ol>
        <p className="mt-10 text-[11px] text-muted sm:text-right">
          Illustrative product concept · Cloud paper trading
        </p>
      </Container>
    </section>
  );
}
